import * as React from 'react';
import classNames from 'classnames';
import Icon from '../../Icon';
import Button from '../../Button';

export interface ModalHeaderProps {
  children?: React.ReactNode;
  className?: string;
  onClose?: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = (props: ModalHeaderProps) => {
  const { children, className, onClose } = props;

  const modalHeaderClass = classNames(className, 'ui-modal-header');

  return (
    <header className={modalHeaderClass}>
      {children}
      {onClose ? (
        <Button
          onClick={onClose}
          btnStyle="flat"
          size="small"
          aria-label="Close"
          iconOnly
        >
          <Icon
            aria-hidden="true"
            className="ui-modal-header-icon"
            name="close"
            size="x-small"
          />
        </Button>
      ) : null}
    </header>
  );
};

export default ModalHeader;
